/**
 * セクショングループ管理者一覧ページ専用i18n定数
 */

export const SECTION_GROUP_ADMIN_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@sectionGroupAdmin.adminList.status.active:有効`,
    inactive: $localize`:@@sectionGroupAdmin.adminList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@sectionGroupAdmin.adminList.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@sectionGroupAdmin.adminList.dialog.confirmMessage:ダイアログが表示されます`,
  },
} as const;

export type SectionGroupAdminListI18n = typeof SECTION_GROUP_ADMIN_LIST_I18N;
